
const switchAsset = (accordion, group) => {  
  const groupAssets = group.querySelectorAll('.laf-accordion__feature');
  const relatedAssetId = accordion?.dataset?.assetId;

  /* === Toggle visibility of related assets === */
  if( relatedAssetId && groupAssets ) {
    Array.from(groupAssets).forEach((asset) => {
      if( asset.id === relatedAssetId ) {
        asset.classList.add('--active');
      } else {
        asset.classList.remove('--active');
      }
    });
  }
}

export default function () {
  const accordionGroups = document.getElementsByClassName('laf-accordion-group')

  if (!accordionGroups) return

  Array.from(accordionGroups).forEach((group) => {
    
    // For animated assets, wait until the animation starts
    group.addEventListener('accordionOpen', (e) => {
      const accordion = e.target;
      switchAsset(accordion, group);
    })
  })

}